import { KeyPrefix } from 'i18next';
import { useTranslation } from 'react-i18next';

export const useTranslationWithPrefix = (
  prefix: KeyPrefix<string>,
): ReturnType<typeof useTranslation<undefined, KeyPrefix<string>>> => {
  return useTranslation(undefined, { keyPrefix: prefix });
};
